import { Component } from '@angular/core';
import { TeamProfile } from '../../models/team-profile';
import { TeamService } from '../../services/team.service';
import { ActivatedRoute } from '@angular/router';
import AppConstants from '../../constants/AppConstants';

@Component({
  selector: 'app-teams',
  templateUrl: './teams.component.html',
  styleUrls: ['./teams.component.scss'],
})
export class TeamsComponent {
  teams: TeamProfile[] = [];
  searchQuery = '';
  count: number;
  readonly DEFAULT_PAGE_SIZE = AppConstants.DEFAULT_PAGE_SIZE;
  readonly DEFAULT_PAGE_SIZE_OPTIONS = AppConstants.DEFAULT_PAGE_SIZE_OPTIONS;
  readonly DEFAULT_PAGINATION_INFO = { pageIndex: 0, pageSize: AppConstants.DEFAULT_PAGE_SIZE };
  pageIndex = 0;
  pageCursors: any[] = [];
  currentPageSize = 10;

  constructor(
    private teamService: TeamService,
    private route: ActivatedRoute,
  ) {
    route.params.subscribe(() => {
      this.fetchList(this.DEFAULT_PAGINATION_INFO);
    });
  }

  pageChanged({ pageIndex, pageSize }) {
    this.fetchList({ pageIndex, pageSize }, this.searchQuery);
  }

  search(input) {
    this.pageIndex = 0;
    this.pageCursors = [];
    this.fetchList({ pageIndex: 0, pageSize: this.currentPageSize }, input);
  }

  private fetchList(pageInfo, searchParam?: string) {
    this.pageIndex = pageInfo.pageIndex;
    const cursorForPage = this.pageIndex > 0 ? this.pageCursors[this.pageIndex - 1] : undefined;
    const obj = {
      paginationData: {
        pageIndex: pageInfo.pageIndex,
        pageSize: pageInfo.pageSize,
        after: cursorForPage,
      },
      searchParam: searchParam,
    };
    this.teamService.getAllTeamProfiles(obj).subscribe((result: any) => {
      if (result && result.data) {
        const data = result.data['teamProfiles'];
        this.teams = data.edges.map((edge) => edge.node);
        this.count = data.totalCount;
        this.pageCursors[this.pageIndex] = data.pageInfo;
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/teams/teams.component.ts